import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { Messages } from "primereact/messages";
import { BreadCrumb } from "primereact/breadcrumb";
import { useMountEffect } from "primereact/hooks";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import Toggle from "../../../components/button/Toggle";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";
//mock data
import { ads, canpaignsOptions } from "../Mock";
//services
import { postFacebookCallback } from "../../../services/Crm/Facebook/postFacebookCallback";
import { useQuery } from "react-query";
import { getFacebookConnected } from "../../../services/Crm/Facebook/getFacebookConnected";
import { getFacebookDisconnect } from "../../../services/Crm/Facebook/getFacebookDisconnect";
import { queryClient } from "../../../utils/queryClient";

const ActiveAds = () => {
  const form = useForm();
  const msgs = useRef(null);
  const navigate = useNavigate();
  const [loadingButton, setLoadingButton] = useState(false);
  const [adsFiltered, setAdsFiltered] = useState(
    ads.filter((ad) => ad.effective_status === "ACTIVE")
  );
  const items = [
    {
      template: () => (
        <Link to={"/crm/ads/active"} className="p-breadcrumb-link">
          Anúncios Ativos
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data, isLoading } = useQuery({
    queryKey: [`connectedFacebook`],
    queryFn: () => getFacebookConnected(),
    // enabled: !!permissions?.includes("101")
  });

  const getFormErrorMessage = (name) => {
    return form.formState.errors[name] ? (
      <small className="p-error">{form.formState.errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const handleSubmit = (data) => {
    const filteredAds = ads
      .filter((ad) => {
        if (data.show_all_ads) {
          return true;
        }
        return ad.effective_status === "ACTIVE";
      })
      .filter((ad) => {
        if (data.canpaign) {
          return ad.campaignId === data.canpaign;
        }
        return true;
      });
    // console.log(filteredAds);
    setAdsFiltered(filteredAds);
  };

  const handleConnectFacebook = () => {
    let redirectUri = window.location.href;

    // let redirectUri = encodeURIComponent(window.location.href);
    // if (!redirectUri.includes('www')) {
    //   redirectUri = encodeURIComponent(https://www.${window.location.hostname}${window.location.pathname});
    // }

    window.location.href = `https://www.facebook.com/dialog/oauth?client_id=485585963515249&scope=ads_read&response_type=token&redirect_uri=${redirectUri}&state=facebook_login`;
  };

  const handleConfirmDisconnect = () => {
    confirmDialog({
      message: "Tem certeza que deseja desconectar do Facebook?",
      header: "Desconectar Facebook",
      icon: "fa-solid fa-triangle-exclamation",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => {
        handleDisconnectFacebook();
      },
    });
  };

  const handleDisconnectFacebook = async () => {
    setLoadingButton(true);
    const notification = toast.loading("Desconectando Facebook...");
    try {
      await getFacebookDisconnect();
      queryClient.setQueryData(["connectedFacebook"], () => {
        return {
          facebook_connected: false,
        };
      });
      setLoadingButton(false);
      toast.update(notification, {
        render: "Facebook desconectado com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      setLoadingButton(false);
      toast.update(notification, {
        render: "Erro ao desconectar Facebook, tente novamente!",
        autoClose: 1000,
        theme: "colored",
        type: "warning",
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    async function fetchData() {
      const hashParams = new URLSearchParams(window.location.hash.slice(1));
      const access_token = hashParams.get("access_token");
      // console.log("Código recebido do Facebook:", access_token);
      if (access_token) {
        try {
          await postFacebookCallback({ access_token });
          queryClient.setQueryData(["connectedFacebook"], () => {
            return {
              facebook_connected: true,
            };
          });
          toast.success("Token salvo com sucesso");
          window.history.replaceState(null, null, " ");
        } catch (error) {
          toast.error("Erro ao salvar token, tente novamente");
        }
      }
    }
    fetchData();
  }, []);

  useMountEffect(() => {
    if (msgs.current) {
      if (!data?.facebook_connected) {
        msgs.current.clear();
        msgs.current.show([
          {
            sticky: true,
            life: 3000,
            severity: "warn",
            summary: "Facebook Desconectado!",
            detail: "Para ter acesso aos anúncios, conecte com o Facebook",
            closable: false,
          },
        ]);
      }
    }
  });

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-md-10">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-md-2 text-end">
          {isLoading ? (
            <div className="d-flex justify-content-end">
              <Skeleton width="20%" className="rounded-circle" height={50} />
            </div>
          ) : (
            <Button
              icon="fa-brands fa-facebook fa-lg"
              className="rounded-circle"
              tooltipOptions={{ position: "left" }}
              // tooltip="Conectar Facebook"
              // severity="info"
              // onClick={() => handleConnectFacebook()}
              loading={loadingButton}
              severity={data.facebook_connected ? "success" : "info"}
              tooltip={
                data.facebook_connected
                  ? "Desconectar Facebook"
                  : "Conectar Facebook"
              }
              onClick={() =>
                data.facebook_connected
                  ? handleConfirmDisconnect()
                  : handleConnectFacebook()
              }
            />
          )}
        </div>
      </div>

      <div className="row">
        <Messages ref={msgs} />
      </div>

      <Panel title="Filtros" mainCss="w-100 my-2">
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <div className="row justify-content-end">
            <div className="col-xl-3 col-md-6">
              <Select
                name="canpaign"
                label={`Campanha`}
                errors={form.formState.errors}
                control={form.control}
                options={canpaignsOptions}
              />
            </div>
            <div className="col-xl-3 col-md-6">
              <Toggle
                name={`show_all_ads`}
                onLabel={`Mostrar Todos`}
                offLabel={`Mostrar Todos`}
                className="mt-3"
                control={form.control}
                getFormErrorMessage={getFormErrorMessage}
              />
            </div>
            <div className="col-xl-6"></div>
            <div className="col-xl-1 col-md-12">
              <Button
                type="submit"
                icon="fa fa-search"
                // loading={loading}
                aria-label="Search"
                className={`rounded-3 w-100`}
              />
            </div>
          </div>
        </form>
      </Panel>

      <Panel title="Biblioteca de Anúncios" mainCss="w-100 mt-3">
        <div className="row">
          {adsFiltered.map((ad) => (
            <div key={ad.id} className="col-xl-3 col-md-6 mb-4 h-100">
              <div className="card h-100">
                {ad.media.video_url ? (
                  <video
                    controls
                    className="card-img-top"
                    alt={ad.name}
                    src={ad.media.video_url}
                    poster={ad.media.thumbnail_url}
                    onLoadedMetadata={(e) => (e.target.currentTime = 0)}
                    style={
                      window.innerWidth > 992 ? { height: "286.09px" } : {}
                    }
                  />
                ) : (
                  <img
                    src={ad.media.image_url ?? ad.media.thumbnail_url}
                    className="card-img-top"
                    alt={ad.name}
                  />
                )}
                <div className="card-body">
                  <h5 className="card-title">{ad.name}</h5>
                  <p className="card-text">Campanha: {ad.campaignName}</p>
                  <p className="card-text">
                    Status:{" "}
                    {ad.effective_status === "ACTIVE" ? (
                      <span
                        className="badge bg-success"
                        style={{
                          fontSize: "10px",
                          marginLeft: "5px",
                        }}
                      >
                        Ativo
                      </span>
                    ) : (
                      <span
                        className="badge bg-danger"
                        style={{
                          fontSize: "14px",
                          marginLeft: "5px",
                        }}
                      >
                        Pausado
                      </span>
                    )}
                  </p>
                  <p className="card-text">Gasto: {formatCurrency(ad.spend)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </>
  );
};

export default ActiveAds;
